export const environment = {
  name: 'dev',
  production: false,
  apiBaseUrl: 'https://dev.pmapi.wealthmax.co.uk/api',
  // Real-user page-speed reports (libs/core/service/web-vitals.ts), received by this
  // app's own Node server (libs/server/web-vitals-collector.ts) and written to the PM2 logs.
  webVitalsUrl: '/web-vitals',
  notificationHubBaseUrl: 'https://dev.pmapi.wealthmax.co.uk',
  solutionBuilderBaseUrl: 'https://dev.pmapi.wealthmax.co.uk',
  swaggerUrl: 'https://dev.pmapi.wealthmax.co.uk/swagger',
  twenty7tec: {
    authorizeUrl: 'https://stagingcloud.twenty7tec.com/OAuth/Authorize',
    clientId: 'cCLR7jDRHg',
    redirectUri: 'https://stg.crm.wealthmax.co.uk/',
    scope: 'SourcingView SourcingEdit',
  }
};